import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { GerarPedidoService } from './gerar-pedido.service';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { NotificationsService } from 'angular2-notifications';
import { HttpParams } from '@angular/common/http';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-gerar-pedido',
  templateUrl: './gerar-pedido.component.html',
  styleUrls: ['./gerar-pedido.component.scss']
})
export class GerarPedidoComponent implements OnInit {

  public formPedidoVenda: FormGroup = null;
  public data = null;
  public cnpj = null;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private service: GerarPedidoService,
    private paginationService: SpringDatatablePaginationService,
    private notificationService: NotificationsService,
    private activatedRoute: ActivatedRoute,
  ) {

    this.formPedidoVenda = this.formBuilder.group({

      estab: [null],
      razaoSocial: [null, Validators.required],
      cnpj: [null, Validators.required],
      valor: [null, Validators.required],
      descricao: [null, Validators.required],

    });

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
  }

  enviarPedido(data) {

    let register = {

      cnpjComprador: this.normalizarCnpjCpfParaBackend(data.cnpj),
      detalhesPedido: data.descricao,
      valorPedido: data.valor,

    }

    this.service.saleRegister(
      register,
      (response) => {
        this.notificationService.success('Pedido Gerado Com Sucesso');
        this.router.navigate(['/pages/compra-online/consulta-pedido-recebido']/*, { relativeTo: this.activatedRoute, queryParams: params }*/);
        this.limparForm();
      }, (error) => {
        this.notificationService.error(error.response.msgRetorno);
      });

  }

  limparForm() {

    this.cnpj = null;
    this.formPedidoVenda = this.formBuilder.group({
      razaoSocial: [null],
      cnpj: [null],
      valor: [null],
      descricao: [null],

    });

  }


  buscaEstab(data) {

    let params = new HttpParams();

    if (data.cnpj != null && String(data.cnpj).trim() !== '') {
      params = params.append('cnpj', this.normalizarCnpjCpfParaBackend(data.cnpj));
    }


    this.service.enterpriseListByCnpj(params, (response) => {

      this.formPedidoVenda.controls['razaoSocial'].setValue(response.razaoSocial);
      this.formPedidoVenda.controls['cnpj'].setValue(this.formatarDocumento(response.cnpj));

    }, null);


  }

  number(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if ((charCode == 45)) {

      this.formPedidoVenda.controls['valor'].setValue(null);
      this.notificationService.error('Não é permitido números negativos!');

    }
    return true;

  }

  getCpfCnpjMask(): string {
    const doForm = this.formPedidoVenda.get('cnpj').value;
    const raw =
      this.cnpj != null && String(this.cnpj).trim() !== ''
        ? this.cnpj
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) return '';
    const str = String(value);
    if (str === '') return '';
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
